import { createAxiosInstance } from "@/plugins/axios.plugin";

const { PLATAFORMA_API_V2 } = process.env;

export class ContentImportService {
  static SERVICE_NAME = "contentImport";

  constructor() {
    this.client = createAxiosInstance({
      baseURL        : PLATAFORMA_API_V2,
      useAccessToken : true
    });
  }

  async importContent(sourceAcademicMainId, body) {
    return this.client.post(`/content/academics-main/${sourceAcademicMainId}/contents/import`, body);
  }
}

export default new ContentImportService();